import React from 'react';
export function Faq() {
  const faqs = [{
    q: '¿Cómo recibo el Kit después de comprar?',
    a: 'Inmediatamente después de acreditado el pago recibís un mail con el link de descarga. En menos de 5 minutos tenés todos los archivos en tu dispositivo. No necesitás instalar nada ni crear una cuenta.'
  }, {
    q: '¿Sirve si trabajo solo, sin asistente?',
    a: 'Sí. La mayoría de los protocolos están diseñados para que los ejecutes vos mismo. Cuando incorpores a alguien nuevo, el Bono 2 ya está listo para entregarle.'
  }, {
    q: '¿Los consentimientos tienen validez legal en Argentina?',
    a: 'Los modelos están basados en la Ley 26.529 de Derechos del Paciente de la República Argentina. Se recomienda revisarlos con un asesor legal antes de la implementación definitiva.'
  }, {
    q: '¿Los 3 bonos están incluidos en las dos ofertas?',
    a: 'Sí. Los tres bonos están incluidos en ambas versiones del kit sin costo adicional.'
  }, {
    q: '¿Sirve si soy especialista (no odontólogo general)?',
    a: 'Sí. Los protocolos de recepción, historia clínica, consentimientos, seguimiento y gestión del equipo aplican a cualquier especialidad odontológica. Los protocolos clínicos específicos son del consultorio general pero el sistema completo funciona para cualquier especialista independiente.'
  }, {
    q: '¿Qué diferencia tiene con plantillas gratis de internet?',
    a: 'Las plantillas de internet están en español neutro o en inglés, son genéricas, no tienen flujo completo y no incluyen instrucciones de implementación. El Kit está hecho específicamente para el consultorio odontológico argentino, con léxico local, basado en la legislación argentina y con una guía de 7 días para implementarlo sin que quede en el cajón.'
  }, {
    q: '¿Por qué elegir la Edición Completa y no el Kit estándar?',
    a: 'Si tenés asistente o querés incorporar uno, o si no sabés exactamente cuánto ganás por mes, la Edición Completa resuelve eso. Por $8.000 pesos más obtenés el Tomo 7 de gestión del equipo y el Tomo 8 de economía del consultorio — los dos que hacen que el sistema sea verdaderamente independiente de tu presencia.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si abrís los tomos, los probás en tu consultorio y sentís que no es lo que esperabas, te devolvemos el 100% sin preguntas. No tenés nada que perder.'
  }];
  return <section className="bg-white px-5 py-10 md:py-[70px] text-center" data-id="element-53">
      <div className="mx-auto max-w-[700px]" data-id="element-54">
        <h2 className="mb-6 md:mb-[44px] font-bebas text-[clamp(28px,5vw,48px)] text-navy" data-id="element-55">
          Preguntas Frecuentes
        </h2>

        <div className="text-left" data-id="element-56">
          {faqs.map((faq, i) => <details key={i} className="group border-b border-brandGray-light py-5" data-id="element-57">
              <summary className="flex cursor-pointer list-none items-center justify-between font-montserrat text-[15px] font-bold text-navy" data-id="element-58">
                {faq.q}
                <span className="text-[22px] font-light text-brandRed group-open:hidden" data-id="element-59">
                  +
                </span>
                <span className="hidden text-[22px] font-light text-brandRed group-open:block" data-id="element-60">
                  −
                </span>
              </summary>
              <p className="mt-3.5 text-[14px] leading-relaxed text-brandGray" data-id="element-61">
                {faq.a}
              </p>
            </details>)}
        </div>
      </div>
    </section>;
}